import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveReplenishmentRequestView = {
  name: "saveReplenishmentRequestView" as const,
  input: z.object({ view: viewSchemas["replenishment-requests"] }),
  output: z.object({}),
};
